import { useEffect, useRef } from "react";

/** Use effect that doesn't run on first render */
const useUpdateEffect = (callback, dependencies) => {
  const firstRenderRef = useRef(true);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    return callback();
  }, dependencies);
};
export default useUpdateEffect;
